import { Card, Col, List, Row, Skeleton, Slider, Space } from "antd";
import Meta from "antd/es/card/Meta";
import React, { memo, useEffect, useRef, useState } from "react";

import {
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./subContacts.module.css";

import { BsFillFilterSquareFill } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import { useLocation, useNavigate } from "react-router-dom";
import img1 from "../../../../assets/staticImages/photoimg1.png";
import img2 from "../../../../assets/staticImages/photoimg2.png";
import img3 from "../../../../assets/staticImages/photoimg3.png";
import img4 from "../../../../assets/staticImages/photoimg4.png";
import Modal from "../../../../components/modal/Modal";
import { roles } from "../../../../config/roles";
import Dropdown from "../../../../components/dropdowns/Dropdown";
import Storage from "../../../../utills/AsyncStorage";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";
import { useDispatch, useSelector } from "react-redux";
import dummyImg from "../../../../assets/dummy.jpg";
import { CurrentLocation } from "../../../../config/CurrentLocation";
import AutoCompleteInput from "../../../../components/auntoCompleteInput/AutoCompleteInput";
import { ZeroEvents } from "../../Events/Events";
import { RiDeleteBinLine } from "react-icons/ri";

import { FaEdit } from "react-icons/fa";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
const RenderItem = memo(({ item, loader }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dispatch = useDispatch();

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }

  const removeVendor = (id) => {
    let data = {
      id: id,
    };
    dispatch(VendorMiddleware.removeSubVendor(data))
      .then(() =>
        dispatch(
          showAlert({
            type: "Success",
            message: "Vendor Removed Successfully",
          })
        )
      )
      .catch(() => { });
  };

  return (
    <List.Item className={styles.listItem}>
      {loader ? (
        <Space
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "10px",
          }}
        >
          <Skeleton.Image active className={styles.image} />
          <Skeleton.Input active size={20} />
        </Space>
      ) : (
        <Card
          onClick={
            loader
              ? null
              : () => {
                navigate("/findVendors/VendorDetails", {
                  state: {
                    headrTitle: role === roles.vendor ? "Staff" : "Profile",
                    data: item,
                    eventData: state?.eventData,
                  },
                });
              }
          }
          hoverable
          className={styles.cardCont}
          style={{ width: "100%", textAlign: "center", alignItems: "center" }}
          cover={
            <div className={styles.imageWrapper}>
              <img
                className={styles.image}
                src={item?.image ? item?.image : dummyImg}
                alt="example"
              />

              <div
                className={styles.dropdownBtnWrapper}
                onClick={(e) => e.stopPropagation()}
              >
                <TextComponent
                  textClass={styles.dropdownBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDropdown(e);
                  }}
                >
                  ...
                </TextComponent>

                {dropdownOpen && (
                  <div className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                    <div
                      className={styles.dropdownItem}
                      onClick={(e) => {
                        e.stopPropagation();
                        removeVendor(item.id);
                      }}
                    >
                      <RiDeleteBinLine fontSize="1.1rem" />
                      <TextComponent textClass={styles.dropdownText}>
                        Delete
                      </TextComponent>
                    </div>
                  </div>
                )}
              </div>
            </div>
          }
        >
          <Meta
            style={{ textAlign: "center" }}
            title={
              <>
                <TextComponent
                  textClass={styles.vendorTitle}
                  text={item?.name}
                />
                {role == roles.vendor && (
                  <TextComponent
                    textClass={styles.vendorJob}
                    text={item.occupation}
                  />
                )}
              </>
            }
          // description={<TextComponent text={item.des} />}
          />


        </Card>
      )}
    </List.Item>
  );
});

const SubContacts = () => {
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [distance, setDistance] = useState(1);
  const [loader, setLoader] = useState(false);
  const [latlng, setlatlng] = useState();
  const [currentLocation, setCurrentLocation] = useState();
  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();

  const SubContactsList = useSelector(
    (state) => state.VendorReducer.SubContacts,
  );
  console.log("SubContactsList", SubContactsList);

  const SubContactsListPagination = useSelector(
    (state) => state.VendorReducer.SubContactsPagination,
  );
  const user = useSelector((state) => state?.AuthReducer?.user);
  // console.log("userSate", user);
  // console.log("state====>subContacts", state);
  // const event_id = state?.eventData?.id;
  const vendor_id =
    role === roles.vendor && state?.screenType != "vendorDetailScreen"
      ? user?.id
      : state?.vendor_id;
  // console.log("Vendor_id", vendor_id);

  let timeout = useRef(null);

  useEffect(() => {
    // dispatch(CurrentLocation.getLiveLocation())
    //   .then((res) => {
    //     setlatlng(res);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    getData();
  }, []);
  const getData = () => {
    setLoader(true);
    let data = {
      search: undefined,
      next_page_url: undefined,
      vendor_id: vendor_id,
      // event_id: event_id,
    };
    dispatch(VendorMiddleware.getSubContacts(data))
      .then(() => {
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };
  const onLoadMore = () => {
    getData({
      search: search,
      next_page_url: SubContactsListPagination?.links?.next,
      vendor_id: vendor_id,
    });
  };
  const onSearch = (e) => {
    let data = {
      vendor_id: vendor_id,
      search: e.target.value,
      next_page_url: SubContactsListPagination?.links?.next,
    };
    setSearch(e.target.value);
    setLoader(true);
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => {
      dispatch(VendorMiddleware.getSubContacts(data))
        .then(() => setLoader(false))
        .catch(() => setLoader(false));
    }, 1500);
  };
  // const onFilter = () => {
  //   getData({
  //     vendor_id: state?.vendor_id,
  //     next_page_url: SubContactsListPagination?.links?.next,
  //     distance: distance ,
  //     address: currentLocation?.address ? currentLocation?.address : null,
  //     lat: currentLocation?.lat ? currentLocation?.lat : latlng?.latitude,
  //     lng: currentLocation?.lng ? currentLocation?.lng : latlng?.longitude,
  //   });
  // };

  console.log(
    "statestate",
    user?.vendor_type != "individual" && !user?.is_subscribed,
  );
  return (
    <>
      {(role === roles.vendor && state?.screenType == "vendorDetailScreen") ||
        role === roles?.client ||
        role === roles?.coHost ? (
        <Row className={styles.searchCont}>
          <SearchInput
            className={styles.searchInput}
            placeholder={"Search"}
            onChange={(e) => onSearch(e)}
          // rightIcon={
          //   <BsFillFilterSquareFill
          //     size={25}
          //     className={styles.filterIcon}
          //     onClick={() => setIsModalOpen(true)}
          //   />
          // }
          />
          {state?.vendorType === "company" && (
            <TextComponent textClass={styles.companyText}>
              Vendors linked to the company are listed here. You can view the
              profile of each vendor for better selection!
            </TextComponent>
          )}
        </Row>
      ) : (
        <Row className={styles.searchContVendor}>
          <Col className={styles.Searchvendor}>
            <SearchInput
              className={styles.searchInput}
              placeholder={"Search"}
              onChange={(e) => onSearch(e)}
            />
          </Col>
          {user?.vendorType != "individual" && user?.is_subscribed ? (
            <Col className={styles.SearchvendorBtn}>
              <SubmitButton
                title="Add New"
                btnClass={styles.addNewBtn}
                onClick={() =>
                  navigate("/addSubVendor", {
                    state: { headrTitle: "Add Staff" },
                  })
                }
              />
            </Col>
          ) : null}
        </Row>
      )}
      <List
        className={styles.listClass}
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 4,
        }}
        dataSource={SubContactsList}
        renderItem={(item) => (
          <RenderItem
            item={item}
            loader={loader}
            footer={
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {SubContactsListPagination?.links?.next != null ? (
                  <div style={{ width: "50%" }}>
                    <SubmitButton title={"Load More"} onClick={onLoadMore} />
                  </div>
                ) : null}
              </div>
            }
          />
        )}
      />
      {/* <Modal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        closable={true}
        className={styles.modal}
      >
        <Row className={styles.modalCont}>
          <TextComponent text={"Filter"} textClass={styles.modalHeading} />
          <TextComponent text={"Distance"} textClass={styles.label} />
          <Row className={styles.distCont}>
            {[1, 500, 1000].map((item) => (
              <Col
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Row>
                  <TextComponent
                    text={`${item} Km`}
                    textClass={`${styles.distText} ${
                      distance >= item ? styles.distTextActive : ""
                    }`}
                  />
                </Row>
                <Row>
                  <GoDotFill
                    size={20}
                    className={`${styles.dotIcon} ${
                      distance >= item ? styles.distTextActive : ""
                    }`}
                  />
                </Row>
              </Col>
            ))}
          </Row>

          <Slider
            defaultValue={1}
            max={1000}
            min={1}
            onChange={setDistance}
            trackStyle={{ backgroundColor: "var(--primary-color)" }}
          />
          <AutoCompleteInput
            label={"Location"}
            placeholder={"Enter Adress"}
            address={currentLocation?.adress}
            onSelectPlace={(place) => {
              let currentLocation = {
                lat: place?.geometry?.location?.lat(),
                lng: place?.geometry?.location?.lng(),
                address: place?.formatted_address,
              };
              setCurrentLocation(currentLocation);
            }}
          />
          <SubmitButton title="Search" btnClass={styles.btnClass} />
        </Row>
      </Modal> */}
      <ZeroEvents
        isModalOpen={
          user?.vendor_type != "individual" &&
          !user?.is_subscribed &&
          role == roles.vendor
        }
        // setIsModalOpen={setIsModalOpen}
        closable={false}
      />
    </>
  );
};

export default SubContacts;
